export const normalizeAccessPersonas = (accessPersonas = [], accessPersona = null) => {
  const values = Array.isArray(accessPersonas)
    ? (accessPersonas.length ? accessPersonas : [accessPersona])
    : [accessPersonas || accessPersona];
  return [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];
};

export const getAdminPersonaScopes = (
  role,
  accessPersonas = [],
  accessPersona = null
) => (
  String(role || '').toLowerCase() === 'persona_admin'
    ? normalizeAccessPersonas(accessPersonas, accessPersona)
    : []
);

export const getAdminPersonaScope = (role, accessPersona = null) =>
  getAdminPersonaScopes(role, accessPersona)[0] || null;

export const isPersonaInAdminScope = (
  role,
  persona,
  accessPersonas = [],
  accessPersona = null
) => {
  const needle = String(persona || '').trim().toLowerCase();
  return getAdminPersonaScopes(role, accessPersonas, accessPersona)
    .some((scope) => scope.toLowerCase() === needle);
};

export const isDomainAdmin = (role) =>
  String(role || '').toLowerCase() === 'persona_admin';

export const hasAdminAccess = (role, accessPersonas = null) =>
  String(role || '').toLowerCase() === 'admin'
  || (isDomainAdmin(role) && getAdminPersonaScopes(role, accessPersonas).length > 0);

export const canManageUsers = (role) =>
  String(role || '').toLowerCase() === 'admin';

export const hasDashboardAccess = (role, accessPersonas = null) =>
  hasAdminAccess(role, accessPersonas)
  || String(role || '').toLowerCase() === 'analyst_reviewer';

export const canManageRequests = (role, accessPersonas = null) =>
  hasAdminAccess(role, accessPersonas)
  || String(role || '').toLowerCase() === 'analyst_reviewer';

export const formatAccessRole = (role) => {
  const normalized = String(role || '').toLowerCase();
  if (normalized === 'admin') return 'Admin (Full Access)';
  if (normalized === 'persona_admin') return 'Persona Admin';
  if (normalized === 'analyst_reviewer') return 'Analyst & Reviewer';
  if (normalized === 'user') return 'User';
  return role;
};
